import Notification from "@/services/echo-manager/notification";

export default class GuildDisbanded extends Notification
{
    handle() {
        //
    }
}